// extracted by mini-css-extract-plugin
export default {"week":"week_week__Op1CA"};